/**
 * Legacy-Redirect: /sites/:id → /dashboard — Issue #36 (Dennis-Entscheid, 2026-09-02)
 *
 * Sites (altes Whitelist-Feature) wird vorerst nicht mehr angeboten.
 * Siehe _auth.sites.tsx.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/sites/$id')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard', replace: true })
  },
  component: () => null,
})
